import { ca } from '@cian/analytics';

export function trackNotificationIconClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Notification',
    action: 'Click',
    label: 'icon',
  });
}
